/* istanbul ignore file */

import * as recommendations from '@noths/polaris-client-recommendations';
import { getUserAttributes } from '@noths/polaris-client-user-configuration';
import getConfig from 'next/config';

import { Placement } from 'src/constants/recommendations';
import { requestSimilarProducts } from 'src/redux/richRelevance/thunks';
import { getStore } from 'src/redux/store';
import { NextConfig } from 'src/types';

const { publicRuntimeConfig } = getConfig() as NextConfig;

export const useAddToCartPlacement = async (
  richRelevanceSessionId: string | undefined,
  productCode: number,
  isModalOpen: boolean,
) => {
  if (!isModalOpen) {
    return;
  }

  const { dispatch } = getStore();

  getUserAttributes().then(async (attributes) => {
    recommendations.initRecommendations({
      apiKey: publicRuntimeConfig.RICH_RELEVANCE_API_KEY,
      env: publicRuntimeConfig.NODE_ENV,
      sessionId: richRelevanceSessionId,
      userId: attributes?.sub,
    });

    recommendations.setProductAddedToBasket(productCode);

    const placementData = await recommendations.getRecommendations([Placement.AddToCart]);
    const addToCartPlacement = placementData.find(
      (placement) => placement.placement_name === Placement.AddToCart,
    );

    if (addToCartPlacement) {
      await dispatch(requestSimilarProducts(addToCartPlacement));
    }
  });
};
